// Role taxonomy, kept in sync with app/routes/auth.py.
//
// A user has one PRIMARY role (what they do on a project) and an optional
// FUNCTION (a review/governance hat they also wear). Admin is a primary role
// too, but it's never self-selectable — it's assigned out-of-band.

export const PRIMARY_ROLES = ['Owner', 'DevOps', 'Developer', 'Sponsor'] as const;
export type PrimaryRole = (typeof PRIMARY_ROLES)[number];

export const FUNCTIONS = ['Reviewer', 'RA/QA', 'Compliance', 'AI Council'] as const;
export type FunctionCategory = (typeof FUNCTIONS)[number];

// Primary roles an admin may assign in the Admin UI (includes Admin itself).
export const ASSIGNABLE_ROLES = ['Owner', 'DevOps', 'Developer', 'Sponsor', 'Admin'] as const;

export const EARLENS_DOMAIN = 'earlens.com';
export const isEarlensEmail = (email: string): boolean =>
  email.trim().toLowerCase().endsWith('@' + EARLENS_DOMAIN);
